import React, { useEffect, useState } from 'react';
import { httpGet, httpUrl, imageUrl } from '../../api/httpClient';
import { reactLocalStorage } from 'reactjs-localstorage';
import Const from '../../const';

function Popup({ onClose, maskClosable, closable, visible, frPopup }) {
  const onMaskClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose(e);
    }
  };

  // 이전방문 날짜
  const VISITED_BEFORE_DATE = localStorage.getItem('VisitCookie');
  // 현재 날짜
  const VISITED_NOW_DATE = Math.floor(new Date().getDate());

  const [popup, setPopup] = useState(frPopup);

  useEffect(() => {
    // 팝업 오늘 하루닫기 체크
    if (VISITED_BEFORE_DATE !== null) {
      // 날짜가 같을경우 노출
      if (Number(VISITED_BEFORE_DATE) === VISITED_NOW_DATE) {
        localStorage.removeItem('VisitCookie');
        onClose(true);
      }
      // 날짜가 다를경우 비노출
      if (Number(VISITED_BEFORE_DATE) !== VISITED_NOW_DATE) {
        onClose(false);
      }
    }
  }, [VISITED_BEFORE_DATE]);

  // 하루동안 팝업 닫기
  const Dayclose = (e) => {
    if (onClose) {
      onClose(e);

      const expiry = new Date();
      // +1일 계산
      const expiryDate = expiry.getDate() + 1;
      // 로컬스토리지 저장
      localStorage.setItem('VisitCookie', expiryDate);
    }
  };

  const close = (e) => {
    if (onClose) {
      onClose(e);
    }
  };

  return (
    <>
      <div
        style={{
          boxSizing: 'border-box',
          display: `${(props) => (props.visible ? 'block' : 'none')}`,
          //   display: "block",
          position: 'fixed',
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          backgroundColor: `rgba(0, 0, 0, 0.6)`,
          zIndex: 999,
        }}
        visible={visible}
      />
      <div
        style={{
          boxSizing: 'border-box',
          display: `${(props) => (props.visible ? 'block' : 'none')}`,
          //   display: "block",
          position: 'fixed',
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          zIndex: 1000,
          overflow: 'auto',
          outline: 0,
        }}
        // className={className}
        onClick={maskClosable ? onMaskClick : null}
        tabIndex="-1"
        visible={visible}>
        <div
          tabIndex="0"
          
          style={{
            boxSizing: 'border-box',
            position: 'relative',
            // boxShadow: `0 0 6px 0 rgba(0, 0, 0, 0.5)`,
            backgroundColor: '#fff',
            // border-radius: 10px;
            width: '100%',
            maxWidth: '1600px',
            top: '50%',
            transform: `translateY(-50%)`,
            margin: 'auto',
            /** 여기 */
            padding: '5px 5px',
          }}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}>
            <div
              className="modal-inner"
              style={
                popup !== null
                  ? {
                      backgroundImage: `url(${imageUrl(popup.uploadFileIdx)})`,
                    }
                  : { backgroundImage: '' }
              }></div>
            {closable && (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  backgroundColor: '#fff',
                  width: '100%',
                  padding: '15px',
                  borderRadius: '0 0 15px 15px',
                  color: '#ffffff',
                  textAlign: 'center'
                }}>
                <span
                  style={{ cursor: 'pointer', color: '#574f4e', fontSize: 14, flex: 2 }}
                  className="modal-close"
                  onClick={Dayclose}>
                  오늘 하루 닫기
                </span>
                <span
                  style={{ cursor: 'pointer', color: '#574f4e', fontSize: 14, flex: 1 }}
                  className="modal-close"
                  onClick={close}>
                  닫기
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default React.memo(Popup);
